module.exports = __webpack_public_path__ + "img/Aldus.39c1fabb.svg";